// Links on the chart navbar only visible to users with Charts permissions
export var chartPermissionsNavBarLinks = [
    {
        linkName: 'FACESHEET',
        displayName: 'Facesheet',
        displayOrder: 0,
        url: '/facesheet-ui/api/viewFacesheet/patient/{patientId}',
        canBeConfigured: false,
    },
    {
        linkName: 'HISTORY',
        displayName: 'History',
        displayOrder: 1,
        url: '/EhrWebApp/patients/viewPatientHistory/{patientId}',
        canBeConfigured: false,
    },
    {
        linkName: 'PROBLEMS',
        displayName: 'Problems',
        displayOrder: 2,
        url: '/EhrWebApp/patients/viewProblems/{patientId}',
        canBeConfigured: false,
    },
    {
        linkName: 'MEDICATIONS',
        displayName: 'Medications',
        displayOrder: 3,
        url: '/patients/{patientId}/medications',
        canBeConfigured: false,
    },
    {
        linkName: 'IMMUNIZATIONS',
        displayName: 'Immunizations',
        displayOrder: 4,
        url: '/EhrWebApp/patients/viewImmunizations/{patientId}',
        canBeConfigured: true,
    },
    {
        linkName: 'ALLERGIES',
        displayName: 'Allergies',
        displayOrder: 5,
        url: '/EhrWebApp/patients/viewAllergies/{patientId}',
        canBeConfigured: false,
    },
    {
        linkName: 'VITALS',
        displayName: 'Vitals',
        displayOrder: 6,
        url: '/EhrWebApp/patients/viewVitals/{patientId}',
        canBeConfigured: true,
    },
];
// Links on the chart navbar only visible to users with Notes permissions
export var notesPermissionsNavBarLinks = [
    {
        linkName: 'NOTES',
        displayName: 'Notes',
        displayOrder: 7,
        url: '/notes-ui/#/notes-list/{patientId}',
        canBeConfigured: false,
    },
];
// Links on the chart navbar only visible to users with Labs permissions
export var labsPermissionsNavBarLinks = [
    {
        linkName: 'LABS',
        displayName: 'Labs/Studies',
        displayOrder: 8,
        url: '/labs-ui/#/patient/{patientId}/labState/all',
        canBeConfigured: true,
    },
];
// Links on the chart navbar only visible to users with Flowsheets permissions
export var flowsheetsPermissionsNavBarLinks = [
    {
        linkName: 'FLOWSHEETS',
        displayName: 'Flowsheets',
        displayOrder: 9,
        url: '/flowsheets-ui/#/{patientId}',
        canBeConfigured: true,
    },
];
// Links on the chart navbar visible to billers/all user types with patient access
export var billerPermissionsNavBarLinks = [
    {
        linkName: 'DEMOGRAPHICS',
        displayName: 'Demographics',
        displayOrder: 10,
        url: '/EhrWebApp/patients/viewDemographics/{patientId}',
        canBeConfigured: false,
    },
    {
        linkName: 'ACCOUNT',
        displayName: 'Account',
        displayOrder: 11,
        url: '/billing-profiles-ui/#/billing-profiles/{patientId}/patient-account-history',
        canBeConfigured: false,
    },
];
// Links on the chart navbar only visible to users with Care Checklist permissions
export var careChecklistPermissionsNavBarLinks = [
    {
        linkName: 'CARE_CHECKLIST',
        displayName: 'Care Checklist',
        displayOrder: 12,
        url: '/EhrWebApp/patients/viewFlowSheets/{patientId}',
        canBeConfigured: false,
    },
];
// Links on the chart navbar only visible to users with Document feature
export var documentsPermissionsNavBarLinks = [
    {
        linkName: 'DOCUMENTS',
        displayName: 'Documents',
        displayOrder: 13,
        url: '/EhrWebApp/patients/viewDocuments/{patientId}',
        canBeConfigured: false,
    },
];
// Links on the chart navbar only visible to users with Recall permissions
export var recallPermissionsNavBarLinks = [
    {
        linkName: 'RECALL',
        displayName: 'Recall',
        displayOrder: 14,
        url: '/admin-ui/#/recall/{patientId}',
        canBeConfigured: false,
    },
];
// Links on the chart navbar for Care Team
export var careTeamPermissionsNavBarLinks = [
    {
        linkName: 'CARE_TEAM',
        displayName: 'Care Team',
        displayOrder: 16,
        url: '/v2/#/patient-history-ui/{patientId}/care-team',
        canBeConfigured: false,
    },
];
// Patient Messages in Facesheet is only visible with this feature flag on
export var FEATURE_FLAG_TO_SHOW_MESSAGES_IN_FACESHEET = 'dark-feature.patient-messages-facesheet';
export var FEATURE_FLAG_MESSAGE_CENTER_ON_WEB_APP_V2 = 'dark-feature.message-center.v2';
// Patient Messages in Facesheet is shown as full width with this feature flag on
export var FEATURE_FLAG_TO_SHOW_MESSAGES_IN_FULL_WIDTH = 'dark-feature.message-center-full-width';
export var PREFERRED_NAME_PRONOUNS_FT = 'dark-feature.clinical-preferred-name-pronouns';
export var COMING_SOON_MESSAGE = 'Patient actions, such as printing patient education, creating prescriptions and ordering labs will be coming soon.';
